import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    // Critical Illness form
    whatEventHappenedForCritical: '',
    whatDateThisOccur: '',
    areYouInACareFacilityCurrentlyForCritical: 'false',
    typeOfCareFacilityForCritical: '',
    enableTimeForCritical: '',
    // Disability form
    whatEventHappenedForDisability: '',
    dateOfAccidentForDisability: '',
    areYouInACareFacilityCurrentlyForDisability: 'false',
    typeOfCareFacilityForDisability: '',
    enableTimeForDisability: '',
    // Dismemberment form
    natureOfDismemberment: '',
    whatDateDidThisOccurForDismemberment: '',
    didYouGoToAHospitalCurrentlyForDismemberment: 'false',
    areYouInACareFacilityCurrentlyForDismemberment: 'false',
    typeOfCareFacilityForDismemberment: '',
    // Leave of Absence form
    didYourEmployerAllowYouAnApprovedLeaveOfAbsence: 'false',
    onWhatDateDidYourLeaveStart: '',
    employerName: '',
    employerEmail: '',
    areYouRetired: '',
    // Death form
    dateOfDeath: '',
  },
  errors: [],
});

function medicalHardshipStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default medicalHardshipStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/reducer.js